import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaClipboardList,
  FaConciergeBell,
  FaUsers,
  FaCalendarCheck,
  FaSignOutAlt
} from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const VendorSidebar = ({ closeSidebar }) => {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();

  const handleLogout = () => {
    logoutUser();
    navigate("/");
    closeSidebar && closeSidebar();
  };

  return (
    <div
      className="bg-side text-white d-flex flex-column dashboard-side-panel"
    >
      <div className="p-3">
        <h4 className="text-center mb-4">Vendor Panel</h4>

        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <NavLink to="/vendor/dashboard" className="nav-link text-white"
              onClick={closeSidebar}>
              <FaTachometerAlt className="me-2" />
              Dashboard
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink to="/vendor/vprofile" className="nav-link text-white"
              onClick={closeSidebar}>
              <FaClipboardList className="me-2" />
              Profile
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink to="/vendor/my-services" className="nav-link text-white"
              onClick={closeSidebar}>
              <FaConciergeBell className="me-2" />
              My Services
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink to="/vendor/vendorstudent" className="nav-link text-white"
              onClick={closeSidebar}>
              <FaUsers className="me-2" />
              Vendor Students
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink to="/vendor/bookings" className="nav-link text-white"
              onClick={closeSidebar}>
              <FaCalendarCheck className="me-2" />
              Service Bookings
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="p-3">
        <button
          onClick={handleLogout}
          className="btn btn-danger w-100 d-flex align-items-center justify-content-center"
        >
          <FaSignOutAlt className="me-2" />
          Logout
        </button>
      </div>
    </div>
  );
};

export default VendorSidebar;
